import React, { useState, useEffect } from 'react';
import axios from 'axios';
import link from '../link';
import { useNavigate } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button } from 'react-bootstrap';

function UserLogin() {
    const navigate = useNavigate();
    const [data, setData] = useState('');
    useEffect(() => {
        const token = sessionStorage.getItem('token');
        const usertype = sessionStorage.getItem('usertype');
        // console.log(token)
        if (token !== '' && usertype === 'user') {
            // console.log(token, usertype);
            navigate('/');
        } else if (token === undefined && usertype === 'admin') {
            navigate('/admin');
        }
        axios.get(`${link.apiUrl}/api/misdashboardlogin`, {
            headers: {
                'x-auth-token': JSON.parse(token)
            }
        }).then(res => {
            setData(res.data);
            // console.log(res.data);
        })
    }, []);

    return (
        <div className='padding20'>
            <h2 className="dashboardtitleheadertext mb20 text-center">
                User Details
            </h2>
            <Row>
                <Col md={3}></Col>
                <Col className="boxshadow pt20" md={6}>
                    <Button className='mb20 ml20 float-end' onClick={() => { navigate('/admin') }}>Log Out</Button>
                    <Button className='mb20 float-end' onClick={() => { navigate('adduserlogin') }}>Add User</Button>
                    {/* <h2 className="smallheading mb20 text-end">
                        Add User
                    </h2> */}
                    <Table striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th className='text-start fs-5'>Organization Name</th>
                                <th className='text-start fs-5'>Login Id</th>
                                <th className='text-start fs-5'>Phone</th>
                                {/* <th className='text-start fs-5'>View</th> */}
                                <th className='text-start fs-5'>View / Edit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.length !== 0 ? data?.map((d) => {
                                return <tr key={d._id}>
                                    <td className='text-start fs-5'>{d.organizationName}</td>
                                    <td className='text-start fs-5'>{d.loginId}</td>
                                    <td className='text-start fs-5'>{d.phone}</td>
                                    {/* <td className='text-start'><Button>View</Button></td> */}
                                    <td className='text-start'>
                                        <Button onClick={() => {
                                            navigate('adduserlogin/' + d._id)
                                        }}>View / Edit</Button>
                                    </td>
                                </tr>
                            }) : null}
                        </tbody>
                        {/* <tr>
                                <td>1</td>
                                <td>Mark</td>
                                <td>Otto</td>
                                <td>@mdo</td>
                                <td>@mdo</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Jacob</td>
                                <td>Thornton</td>
                                <td>@mdo</td>
                                <td>@fat</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td colSpan={2}>Larry the Bird</td>
                                <td>@mdo</td>
                                <td>@twitter</td>
                            </tr> */}
                    </Table>
                </Col>
                <Col md={3}></Col>
            </Row>
        </div>
    );
}

export default UserLogin;
